//SocketContext.context.js
import { createContext, useContext } from "react";

const SocketContext = createContext();

export const useSocketContext = () => {
  return useContext(SocketContext);
};

export default SocketContext;
